import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-error-message',
    templateUrl: './error-message.component.html',
    styleUrls: ['./error-message.component.scss'],
})
export class ErrorMessageComponent implements OnInit {
    @Input() errorMessage: string;
    @Input() errorMessages: string[];
    constructor() {}

    ngOnInit(): void {}
}
